import { render } from "./ExpedientDetailBurofaxes.vue?vue&type=template&id=4094cb12"
import script from "./ExpedientDetailBurofaxes.vue?vue&type=script&lang=js"
export * from "./ExpedientDetailBurofaxes.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__